import { useState, useCallback } from 'react';
import { SortInfo } from '@/app/shared/api/endpoints/SearchInvoices';
import { TableSortDirection } from '@triumph/design-system';

export interface UseInvoiceSortingReturn {
  sortConfig: SortInfo[];
  handleOnSort: (field: string, direction?: TableSortDirection) => void;
  resetSort: () => void;
}

const DEFAULT_SORT: SortInfo[] = [{ field: 'age', order: 'desc' }];

export const useInvoicesSorting = (
  onSortChange?: () => void,
): UseInvoiceSortingReturn => {
  const [sortConfig, setSortConfig] = useState<SortInfo[]>(DEFAULT_SORT);

  const handleOnSort = useCallback(
    (field: string, direction?: TableSortDirection) => {
      onSortChange?.();

      setSortConfig((prevSort) => {
        if (direction !== undefined) {
          if (direction === TableSortDirection.None) {
            return DEFAULT_SORT;
          }
          return [
            {
              field,
              order:
                direction === TableSortDirection.Ascending ? 'asc' : 'desc',
            },
          ];
        }

        const existingSort = prevSort.find((s) => s.field === field);

        if (existingSort) {
          if (existingSort.order === 'asc') {
            return [{ field, order: 'desc' }];
          } else {
            return DEFAULT_SORT;
          }
        } else {
          return [{ field, order: 'asc' }];
        }
      });
    },
    [onSortChange],
  );

  const resetSort = useCallback(() => {
    setSortConfig(DEFAULT_SORT);
  }, []);

  return {
    sortConfig,
    handleOnSort,
    resetSort,
  };
};
